export const buttonStyle = {
	bg:'green.300',
	boxShadow:'md', 
	rounded:'md',
	textColor:'white',
};

export const pageHeaderStyle = {
	color: 'green.400',
	textAlign: 'center',
	textDecor: 'underline',
	m: '10px'
};

export const lineItemStyle = {
	maxHeight: '25px',
	textAlign: 'center'
};
